export default {
  jelBtn: {
    border: '1px solid #fff',
    padding: '0px 3px',
    borderRadius: '24px',
    margin: '1px',
    '&:hover': {
      backgroundColor: '#fff',
    },
  },
  tableRow: {
    '&:hover': {
      background: '#EEECF8',
      '& .jel-btn': {
        border: '1px solid #D9D8ED',
      },
      '& .jel-btn:hover': {
        background: '#fff',
        border: '1px solid #D9D8ED',
        '& .open-jel-icon-toggle': {
          visibility: 'visible',
        }
      },
    },
  },
  tableCellId: {
    width: 85,
    fontSize: 12,
    color: '#4C4C4C',
    boxSizing: 'border-box',
    position: 'relative',
  },
  tableCellTitle: {
    width: 210,
    boxSizing: 'border-box',
    position: 'relative',
  },
  tableCellConcept: {
    width: 140,
    boxSizing: 'border-box',
    position: 'relative',
  },
  openJelIcon: {
    margin: '0 5px',
    height: '20px',
    visibility: 'hidden',
  },
  elementHeading: {
    fontSize: 12,
    color: '#4E4C4C',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  theadResizer: {
    width: 2,
    right: 0,
    height: 16,
    display: 'flex',
    padding: '0 3px',
    cursor: 'w-resize',
    position: 'absolute',
  },
  theadResizerLine: {
    width: '1px',
    backgroundColor: '#B9BBCD',
  },
  tableRowBtn: {
    fontSize: 20,
    color: '#B9BBCD',
    '&:hover': {
      color: '#4c4c4c',
      cursor: 'pointer',
    },
  },
  tableRowDeleteBtn: {
    '&:hover': {
      color: '#E91818',
      cursor: 'pointer',
    },
  },
  jel: {
    flexShrink: 0,
    '&:hover': {
      background: '#EEECF8',
    },
  },
  jelsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  jelIcon: {
    fontSize: 16,
    marginRight: 12,
  },
  jelTitle: {
    padding: '1px 3px 1px 0',
    fontSize: 12,
    color: '#4E4C4C',
    textTransform: 'none',
  },
  addNewElemHeading: {
    fontSize: 12,
    color: '#347CFF',
    textTransform: 'none',
  },
  jelSettings: {
    width: '150px',
    color: '#4E4C4C',
    wordBreak: 'break-word',
    marginRight: '15px',
    lineHeight: '14px',
  },
};
